import tripoolSwapABI from './json/3pool/swap';

const multicall_address = '0xace58a26b8Db90498eF0330fDC9C2655db0C45E2';

const poolsData = {
    '3pool': {
        swap_abi: tripoolSwapABI,
        N_COINS: 3,
        coin_precisions: [1e18, 1e6, 1e6],
        wrapped_precisions: [1e18, 1e6, 1e6],
        tethered: [false, false, false],
        use_lending: [false, false, false],
        is_plain: [true, true, true],
        swap_address: '0xbF7E49483881C76487b0989CD7d9A8239B20CA41',
        token_address: '0xbF7E49483881C76487b0989CD7d9A8239B20CA41',
        gauge_address: '0xC2b1DF84112619D190193E48148000e3990Bf627',
        underlying_coins: [
            '0xe3520349F477A5F6EB06107066048508498A291b',
            '0xB12BFcA5A55806AaF64E99521918A4bf0fC40802',
            '0x4988a896b1227218e4A686fdE5EabdcAbd91571f',
        ],
        coins: [
            '0xe3520349F477A5F6EB06107066048508498A291b',
            '0xB12BFcA5A55806AaF64E99521918A4bf0fC40802',
            '0x4988a896b1227218e4A686fdE5EabdcAbd91571f',
        ],
    }
};

export {
    multicall_address,
    poolsData,
};
